import { MILLISECONDS_IN_A_SECOND } from "../resources/APP_CONSTANTS";

export const isTokenExpired = (expiry: number): boolean =>
  expiry < Date.now() / MILLISECONDS_IN_A_SECOND;
